import React, { Component } from "react";
import {
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import Calender from "../calender";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { redirect } from "../../../slices/sbHebergSlice";
import httpClient from "../../../httpClient";
import { faMapMarkerAlt, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UrlParams from "../urlParams";
import { Slider} from "@mui/material";
import { searchedLocation, sideBarLocation } from "../../../slices/sbLocation";

class SideBarTransfert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParams :{
        pays: "",
        region: "",
        commune :"",
        regionDepart: "",
        regionArrive: "",
        stationDepart: "",
        stationArrive: "",
        dateDepart: "",
        dateArrive: "",
        carType: [],
        transfertType : "",
        conditions: [],
        equipement: [],
        budget : 100,
        budgetIntervale : []
      },
      autocompletePlaces:[],
      showAutoComp : {regionDepartShow :false , regionArriveShow : false, stationDepartShow : false, stationArriveShow:false }
    };
    this.showAutoComp = this.showAutoComp.bind(this);

  }


 async componentDidUpdate(prevProps, prevState) {
    this.props.dispatch(sideBarLocation(this.state.searchParams));
    if(this.props.redirect===true && prevProps.url !== this.props.url){
      console.log(this.props.url);
      this.props.history.push("/cars/transfert/advanced_search"+"?"+this.props.url)
      const searchedAnnounces = await httpClient.getAllCarsTransfert(this.props.url)
      this.props.dispatch(searchedLocation(searchedAnnounces))
      this.props.dispatch(redirect(false))
    }
  }

  async componentDidMount(){
    let completeUrl = decodeURIComponent(window.location.href.toString())
    let prms = completeUrl.replace(window.location.hostname.toString() , "").replace(window.location.pathname.toString() , "")
    let pos = prms.indexOf("?")
    prms = prms.substring(pos+1,prms.length)
    let urlParams = new UrlParams(prms,0).params
    let obj = this.state.searchParams

    Object.entries(urlParams).map(prop =>{
     if (prop[0] ==="carType"  || prop[0] ==="conditions" || prop[0] ==="equipement") {
      obj[prop[0]] = prop[1].replaceAll('+'," ").split(',')
     }
     else obj[prop[0]] = prop[1]
    })
    this.setState({
      searchParams : obj
    })
    const searchedAnnounces = await httpClient.getAllCarsTransfert(this.props.url||prms)

    this.props.dispatch(searchedLocation(searchedAnnounces))
    this.props.dispatch(redirect(false))
  }

  isExist(type , value){
    let copie = this.state.searchParams[type]
    return copie.includes(value)
  }

  changeState(evt) {
    let value = evt.target.value;
    let name = evt.target.name;
    const copie = this.state.searchParams[name];
    
    this.setState({
      searchParams : {
        ...this.state.searchParams,
      [name]: value,
      }
      
    });

    if (evt.target.type === "radio") {
      this.setState({
        searchParams : {
          ...this.state.searchParams,
          budget: value,
        }
      });
    } else if ((evt.target.type === "checkbox")) {
      let index = copie.indexOf(value);
      if (index === -1) {
        this.setState({
          searchParams : {
            ...this.state.searchParams,
            [name]: [...this.state.searchParams[name], value],
          }
        });
      } else {
        this.setState({ 
          searchParams : {
            ...this.state.searchParams,
            [name]: copie.filter((item) => item !== value),
          }
        });
      }
    }
  }

  city(e,city,country){
    e.preventDefault()
    this.setState({
      searchParams : {
        ...this.state.searchParams,
        pays: country,
        region:city,
      },
      showAutoComp : {regionDepartShow :false , regionArriveShow : false, stationDepartShow : false, stationArriveShow:false }
      },
    )
  }


  handleChangeBudget =  (event, newValue) => {
    let budgetIntervale ;
    switch (newValue) {
      case 0:
        budgetIntervale = "0-50000"
        break;
      case 25:
        budgetIntervale = "50000-100000"
        break;
      case 50:
        budgetIntervale = "10000-200000"
      case 75:
        budgetIntervale = "200000-300000"
      case 25:
        budgetIntervale = "300000-9999999"
        break;   
      default:
        break;
    }
    this.setState({
      searchParams: {
        ...this.state.searchParams,
        budget : newValue,
        budgetIntervale :budgetIntervale
      }
    })

  };

   autoComplete(evt) {
    try {
      if (evt.target.value !=="") {
        // httpClient.autocompletePlaces(evt.target.value).then((res)=>{
        //   if (res){ 
        //     this.showAutoComp(true)
        //     return this.setState({autocompletePlaces:res.data})  
        //   }
        //}
        //)
      
      }
        
      
    } catch (error) {
      console.log(error);
    }
  }

  showAutoComp(value , type){
    this.setState({
      showAutoComp : {
          ...this.showAutoComp ,
          [type] : value
      }
    })
  }
  
    render() { 
          

        const marks = [
            // Save the fetched values here instead of under <Slider value=...>
            { value: 0, label: '<50k' },
            { value: 25, label: '50k-100k' },
            { value: 50, label: '100k-200k' },
            { value: 75, label: '200k-300k' },
            { value: 100, label: '+300k' },
          ];

      const showAutoComp = this.state.showAutoComp
      const regionDepart  = this.state.searchParams.regionDepart
      const regionArrive  = this.state.searchParams.regionArrive
      const stationDepart  = this.state.searchParams.stationDepart
      const stationArrive  = this.state.searchParams.stationArrive

      const citiesDepartRegion =  <DropdownItem className="pl-1"  onMouseDown={e=>{this.city.bind(this)(e,regionDepart,"Algerie")}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name="regionDepart"/> {regionDepart}</DropdownItem>
      
      const citiesArriveRegion =  <DropdownItem className="pl-1"  onMouseDown={e=>{this.city.bind(this)(e,regionArrive,"Algerie")}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name="regionArrive"/> {regionArrive}</DropdownItem>
      const citiesDepartStation =  <DropdownItem className="pl-1"  onMouseDown={e=>{this.city.bind(this)(e,stationDepart,"Algerie")}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name="regionArrive"/> {stationDepart}</DropdownItem>
      const citiesArriveStation =  <DropdownItem className="pl-1"  onMouseDown={e=>{this.city.bind(this)(e,stationArrive,"Algerie")}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name="regionArrive"/> {stationArrive}</DropdownItem>

      // const citiesDepart = this.state.autocompletePlaces.map((city,i)=>{
      //   const cityName = city.name ;
      //   const code = city.address.cityCode;
      //   const country = city.address.countryCode;
      //   const countryName = city.address.countryName;
      //   return (
      //    <DropdownItem className="pl-1" id={`cityDep`+i} key={city.address.cityCode} onMouseDown={e=>{this.city.bind(this)(e,cityName,countryName)}} ><FontAwesomeIcon  icon={faMapMarkerAlt} name={city.address.cityCode}/> {cityName} ({code}, {country})</DropdownItem>
      //   )},this)
  
      const carType = ["Mini Citadine","Citadine","Berline","Moyenne Berline","SUV Tout-terrain","Grande Berline","Break Familliale","Coupé Cabriolet","Van","Mini Bus","Bus / Navette"]
      const condReserv= ["Annulation gratuite", "Paiment sur place" ," Paiment électronique", "Paiment sécurisé sur site"]
      const equipement = ["Véhicule VIP","Porte Bagage","Climatisation","Siège Bébé"]
      
      const carTypeeElm = [] ;
      const equiElm = [];  
      const condReservElm = [] ;




      carType.forEach(elm =>{
        carTypeeElm.push(
          <FormGroup check className="check-box form-check-sidebar"><Label check><Input name='carType' type="checkbox" value={elm} checked={this.isExist("carType",elm)} />{elm}</Label></FormGroup>
        )
      })
      condReserv.forEach(elm =>{
        condReservElm.push(
          <FormGroup check className="check-box form-check-sidebar"><Label check><Input name="conditions" type="checkbox" value={elm} checked={this.isExist("conditions",elm)} />{elm}</Label></FormGroup>
          )
      })
      equipement.forEach(elm =>{
        equiElm.push(
          <FormGroup check className="check-box form-check-sidebar"><Label check><Input name='equipement' type="checkbox" value={elm} checked={this.isExist("equipement",elm)} />{elm}</Label></FormGroup>
          )
      })
        return ( 
            <Container>
            <br />
          <center><span className="side-bar-txt header-sd-br">Recherche Avancée</span></center>
          <br />
          <div>
          <form onChange={e=>{this.changeState(e)}}>
          <div>



                <div className='d-flex mt-1'>
                  <UncontrolledDropdown className='mr-2' style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="toggleSideBar" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                          Multi-destin
                          <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                  </DropdownToggle>
                 <DropdownMenu className="destination-drop-down">
                        <DropdownItem>choix 1</DropdownItem>
                        <DropdownItem>choix 2</DropdownItem>
                </DropdownMenu>
                </UncontrolledDropdown>


                  <UncontrolledDropdown  style={{width:"50%"}} >
                  <DropdownToggle id="destination" className="Advanced-btn-ser small" style={{width:"100%",backgroundColor:"white",color:"#37296a",textAlign:"left"}}>
                         Aiereport   
                         <img src="/imgs/navebar/downArrow.svg" alt="" id="arrow-parcourir-big"/>
                </DropdownToggle>
                <DropdownMenu className="destination-drop-down">
                        <DropdownItem>choix 1</DropdownItem>
                        <DropdownItem>choix 2</DropdownItem>
                </DropdownMenu>
                </UncontrolledDropdown>

                </div>     

                <div className="mt-1">
                <div className="lablel-sidebar" id="cancel-side">Lieu de départ</div>
                <UncontrolledDropdown nav inNavbar>
                    <input onChange={e=>this.changeState(e)} onInput={e=>this.autoComplete(e)} onFocus={e=>this.showAutoComp(true,"regionDepartShow")}  onBlur={e=>this.showAutoComp(false,'regionDepartShow')}  className="Advanced-btn-ser small" placeholder=' Skikda,skikda' style={{width:"100%",backgroundColor:"white",color:"#37296a",border:"none"}} name="regionDepart" value={this.state.searchParams.regionDepart}/>
                    <DropdownMenu className={`${showAutoComp.regionDepartShow&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> 
                            {citiesDepartRegion}
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown> 
                </div>



                <div >
                <div className="lablel-sidebar" id="cancel-side">station de départ</div>
                <UncontrolledDropdown nav inNavbar>
                    <input onChange={e=>this.changeState(e)} onInput={e=>this.autoComplete(e)} onFocus={e=>this.showAutoComp(true,"stationDepart")}  onBlur={e=>this.showAutoComp(false,"stationDepart")}  className="Advanced-btn-ser small" placeholder=' CZL, Constantine, Algérie' style={{width:"100%",backgroundColor:"white",color:"#37296a"}} name="stationDepart" value={this.state.searchParams.stationDepart}/>
                    <DropdownMenu className={`${showAutoComp.stationDepart&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> 
                            {citiesDepartStation}
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown> 
                </div>
         
                <div className="d-flex justify-content-between">
                    <div>
                      <span className="lablel-sidebar" id="cancel-side">Date de départ</span>
                      <input type="date" name="dateDepart" id="" />
                    </div>
                    <div>
                      <span className="lablel-sidebar" id="cancel-side">Heure de retour</span>
                      <input type="time" name="" id="" />
                    </div>
                </div>

                <div>
                <div className="lablel-sidebar" id="cancel-side">Station de retour</div>
                <UncontrolledDropdown nav inNavbar>
                    <input onChange={e=>this.changeState(e)} onInput={e=>this.autoComplete(e)} onFocus={e=>this.showAutoComp(true,"stationArrive")}  onBlur={e=>this.showAutoComp(false,"stationArrive")}  className="Advanced-btn-ser small" placeholder=' Skikda,skikda' style={{width:"100%",backgroundColor:"white",color:"#37296a"}} name="stationArrive" value={this.state.searchParams.stationArrive}/>
                    <DropdownMenu className={`${showAutoComp.stationArrive&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> 
                            {citiesArriveStation}
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown> 
                </div>


                <div >
                <div className="lablel-sidebar" id="cancel-side">Lieu de retour</div>
                <UncontrolledDropdown nav inNavbar>
                    <input onChange={e=>this.changeState(e)} onInput={e=>this.autoComplete(e)} onFocus={e=>this.showAutoComp(true,"regionArrive")}  onBlur={e=>this.showAutoComp(false,"regionArrive")}  className="Advanced-btn-ser small" placeholder=' CZL, Constantine, Algérie' style={{width:"100%",backgroundColor:"white",color:"#37296a"}} name="regionArrive" value={this.state.searchParams.regionArrive}/>
                    <DropdownMenu className={`${showAutoComp.regionArrive&&'show'} destination-drop-down`}>
                    <div>
                          <div className="body-drop-down">
                          
                          <div><FontAwesomeIcon id="search-result" icon={faSearch} /><span id="reslt-title"> Résultat</span></div>
                            
                            <hr />
                            <div className="result-block"> 
                            {citiesArriveRegion  }
                             </div>
                             </div>
                        </div>
                    </DropdownMenu>
                  </UncontrolledDropdown> 
                </div>

                <div className="d-flex justify-content-between">
                    <div>
                      <span className="lablel-sidebar" id="cancel-side">Date de retour</span>
                      <input type="date" name="dateArrive" id="" />
                    </div>
                    <div>
                      <span className="lablel-sidebar" id="cancel-side">Heure de retour</span>
                      <input type="time" name="" id="" />
                    </div>
                </div>

                <div className="options-sidebar mt-3">
                <div className="lablel-sidebar-bidget mb-1">Type de Transfert</div>
                <FormGroup check className="check-box form-check-sidebar"><Label check><Input name='transfertType' type="checkbox" value="Collectif" checked={this.isExist("transfertType","Collectif")} />Collectif</Label></FormGroup>
                <FormGroup check className="check-box form-check-sidebar"><Label check><Input name='transfertType' type="checkbox" value="Prive" checked={this.isExist("transfertType","Prive")}/>Privé</Label></FormGroup>
                </div>


                <div className="options-sidebar mt-2">
                <div className="lablel-sidebar-bidget mb-1">Type de Véhicule</div>
                {carTypeeElm}
                </div>


                <div className="lablel-sidebar mt-3">Votre budget</div>
                <div className="mr-1 ml-1">
                <Slider
                  getAriaLabel={() => 'Temperature range'}
                  value={this.state.searchParams.budget}
                  onChange={(event, newValue)=>this.handleChangeBudget(event,newValue)}
                  min ={0}
                  max={100}
                  marks={marks}                  
                  className={"slider-white"}  
                  step={null}  
                  />    
                </div>

                <div className="options-sidebar mt-2">
                 <div className="lablel-sidebar-bidget mb-1">Condition de réservation</div>
                 {condReservElm}
                 </div>

                 <div className="options-sidebar mt-2 mb-4">
                 <div className="lablel-sidebar-bidget mb-1">Equipements</div>                  
                 {equiElm}
                 </div>
                </div>
                </form>
         </div>
         
          </Container>
         );
    }
}
 

function mapStateToProps(state) {
  return {
    url : state.sideBarCarsLocation.url,
    redirect : state.sideBarCarsLocation.redirect,
    params : state.sideBarCarsLocation.sideBar
  };
}

//connect function INJECTS dispatch function as a prop!!
export default withRouter(connect(mapStateToProps)(SideBarTransfert));